import React from 'react'
import classNames from 'classnames'
// Example: using a spinner icon from MUI or your own spinner
import CircularProgress from '@mui/material/CircularProgress'

export const AdvertiserButton = ({
  label = '',
  type = 'button',
  onClick = () => {},
  disabled = false,
  loading = false,
  startIcon = null,
  endIcon = null,
  spinnerSize = 20,
  className = 'py-14 px-24 text-title text-md leading-24 font-bold h-12 bg-[#ffbb00] border-none outline-none gap-2 w-full'
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={classNames(
        'flex cursor-pointer items-center justify-center rounded-sm',
        className
      )}
    >
      {loading ? (
        <CircularProgress size={spinnerSize} color="inherit" />
      ) : (
        <>
          {startIcon && <span className="flex items-center justify-center">{startIcon}</span>}
          {label && <span className="flex items-center justify-center whitespace-nowrap">{label}</span>}
          {endIcon && <span className="flex items-center justify-center">{endIcon}</span>}
        </>
      )}
    </button>
  )
}
